import { Helmet } from 'react-helmet';
import './footer.css'

export default function Footer() {
    return (
        <div>
            
            <footer>
                <p>&copy; 2022 Edition</p> 
                <p>
                    nishanth prajith
                </p>
            </footer>
        </div>
    )
}

